import { Box } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import _ from "lodash";
import MessagesTable from "../../tables/MessagesTable";
import DrawerComponent from "../../misc/Drawer";
import { getMessageSortTimestamp } from "../../../../utils/smsDelays";

const DailyMessageDetails = () => {
  const { messages, messageStatus } = useSelector(
    (state) => state.defaultReducer
  );
  const messagesClone = _.cloneDeep(messages || [])
    .filter(
      (a) =>
        !messageStatus.length ||
        (messageStatus.length && Number(a.deliveryStatus) === Number(messageStatus))
    )
    .sort((a, b) => getMessageSortTimestamp(b) - getMessageSortTimestamp(a));

  return (
    <Box mt={4}>
      <DrawerComponent />
      <MessagesTable messages={messagesClone} />
    </Box>
  );
};

export default DailyMessageDetails;
